import type { Match } from '@uefadigital/panenka';
import { PkDivider } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import MatchResults from './MatchResults';

interface MatchesProps {
  title: string;
  firstHalf: Match[];
  secondHalf: Match[];
}

const Matches = ({ title, firstHalf, secondHalf }: MatchesProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <PkDivider class="divider--horizontal" direction="horizontal" />
        <div className={`${title} pk-pt--xl pk-d--none pr-display--block`}>{t('previous_results')}</div>
      </div>
      <div className="pk-d--flex pk-flex--wrap pk-justify-content--between pk-mt-md--xl">
        <div>
          <MatchResults H2HMatchesToDisplay={firstHalf} />
        </div>
        <div>
          <PkDivider class="divider--vertical pk-px--auto" direction="vertical" />
        </div>
        <div>
          <MatchResults H2HMatchesToDisplay={secondHalf} />
        </div>
        <div className="pk-d--none pr-display--block">
          <PkDivider class="divider--horizontal" direction="horizontal" />
        </div>
      </div>
    </>
  );
};

export default Matches;
